import { render, staticRenderFns } from "./simpleSso.vue?vue&type=template&id=fa5d1da6&"
import script from "./simpleSso.vue?vue&type=script&lang=js&"
export * from "./simpleSso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa5d1da6')) {
      api.createRecord('fa5d1da6', component.options)
    } else {
      api.reload('fa5d1da6', component.options)
    }
    module.hot.accept("./simpleSso.vue?vue&type=template&id=fa5d1da6&", function () {
      api.rerender('fa5d1da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/simpleSso.vue"
export default component.exports